export default "__VITE_ASSET__PqDVB9bu__"